import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { MultiUsersSelectComponent } from '@wilson/non-domain-specific/account/account-helpers';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@Component({
  selector: 'wilson-export-qualification-v2-modal',
  imports: [
    TranslatePipe,
    NzRadioModule,
    NzButtonModule,
    FormsModule,
    MultiUsersSelectComponent,
  ],
  templateUrl: './export-qualification-v2-modal.component.html',
  styleUrl: './export-qualification-v2-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportQualificationV2ModalComponent implements OnInit {
  selectedExportOption = 'all';
  userIds: string[] = [];

  @Output() userIdsChange = new EventEmitter<string[]>();
  @Output() exportOptionChange = new EventEmitter<string>();
  @Output() validityChange = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.checkAndEmitValidity();
  }

  onUserIdsChange(userIds: string[]): void {
    this.userIds = userIds;
    this.userIdsChange.emit(userIds);
    this.checkAndEmitValidity();
  }

  onExportOptionChange(option: string): void {
    this.selectedExportOption = option;
    this.exportOptionChange.emit(option);

    if (option === 'all') {
      this.userIds = [];
      this.userIdsChange.emit(this.userIds);
    }

    this.checkAndEmitValidity();
  }

  private checkAndEmitValidity(): void {
    const isValid =
      this.selectedExportOption === 'all' || this.userIds.length > 0;
    this.validityChange.emit(isValid);
  }

  get isExportButtonDisabled(): boolean {
    return this.selectedExportOption !== 'all' && this.userIds.length === 0;
  }
}
